<template>
  <div class="invite-page">
    <section class="invite-panel">
      <div class="panel-head">
        <div>
          <h2 class="panel-title">邀请有奖</h2>
          <p class="panel-desc">{{ promoSentence }}</p>
        </div>
        <span class="badge">注册有礼 · 邀请有奖</span>
      </div>

      <div class="grid-two">
        <section class="sub-card">
          <h2>填写好友邀请码</h2>
          <div class="field-row">
            <input
              v-model="bindCode"
              type="text"
              class="field-input"
              placeholder="请输入邀请码"
              :disabled="!!boundInviteCode || binding"
            />
            <button
              type="button"
              class="btn-primary-sm"
              :disabled="!!boundInviteCode || binding"
              @click="handleBind"
            >
              {{ binding ? '提交中...' : '确认填写' }}
            </button>
          </div>
          <p v-if="boundInviteCode" class="hint ok">已绑定邀请码：{{ boundInviteCode }}</p>
          <p v-else-if="bindMsg" class="hint warn">{{ bindMsg }}</p>

          <div class="field-row mt">
            <span class="field-label">我的邀请码</span>
            <input type="text" class="field-input" :value="myInviteCode" readonly />
            <button type="button" class="btn-outline-sm" @click="copyMyCode">一键复制</button>
          </div>
        </section>

        <section class="sub-card">
          <h2>邀请好友</h2>
          <p class="sub-desc">分享邀请链接或文案</p>
          <div class="field-row">
            <input type="text" class="field-input" :value="inviteLink" readonly />
            <button type="button" class="btn-outline-sm" @click="copyLink">一键复制</button>
          </div>
          <div class="field-row mt">
            <textarea class="field-textarea" :value="shareText" rows="2" readonly />
            <button type="button" class="btn-outline-sm" @click="copyShareText">一键复制</button>
          </div>
        </section>
      </div>
    </section>

    <section class="stats-panel">
      <div class="stats-head">
        <h2>邀请数据</h2>
        <p>成功邀请的好友会显示在下方列表</p>
      </div>
      <div class="stats-card">
        <div class="stat-item">
          <div class="stat-label">推广人数</div>
          <div class="stat-value">{{ inviteCount }}<span class="unit">人</span></div>
        </div>
      </div>

      <div class="table-wrap">
        <div class="table-head">
          <span>昵称</span>
          <span>注册时间</span>
          <span>您的奖励</span>
        </div>
        <div v-if="records.length === 0" class="table-empty">暂无邀请记录</div>
        <div v-for="(row, idx) in records" :key="idx" class="table-row">
          <span>{{ row.nickName }}</span>
          <span>{{ row.createTime }}</span>
          <span>{{ row.inviterReward }} 字</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getInviteInfo, bindInviteCode } from '@/api/portal/invite'
import { copyText } from '@/utils/invite'
import { buildInvitePromoSentence } from '@/utils/rewardCopy'
import { isLoggedIn } from '@/utils/auth'
import { onLoginSuccess, offLoginSuccess } from '@/utils/loginModal'

export default {
  name: 'InviteView',
  data() {
    return {
      loading: false,
      binding: false,
      bindCode: '',
      bindMsg: '',
      myInviteCode: '',
      inviteLink: '',
      shareText: '',
      boundInviteCode: '',
      inviterReward: 0,
      newMemberReward: 2000,
      inviteCount: 0,
      records: []
    }
  },
  computed: {
    promoSentence() {
      return buildInvitePromoSentence(this.newMemberReward, this.inviterReward)
    }
  },
  mounted() {
    onLoginSuccess(this.tryLoad)
    this.tryLoad()
  },
  beforeDestroy() {
    offLoginSuccess(this.tryLoad)
  },
  methods: {
    tryLoad() {
      if (!isLoggedIn()) {
        this.$emit('require-login')
        return
      }
      this.loadInfo()
    },
    loadInfo() {
      this.loading = true
      getInviteInfo()
        .then(res => {
          const data = res.data || {}
          this.myInviteCode = data.inviteCode || ''
          this.inviteLink = data.inviteLink || ''
          this.shareText = data.shareText || ''
          this.boundInviteCode = data.boundInviteCode || ''
          this.inviterReward = data.inviterReward || 0
          this.newMemberReward = data.newMemberReward || 2000
          this.inviteCount = data.inviteCount || 0
          this.records = data.records || []
        })
        .catch(err => {
          this.bindMsg = err.message || '加载失败'
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleBind() {
      if (!this.bindCode.trim()) {
        this.bindMsg = '请填写邀请码'
        return
      }
      this.binding = true
      this.bindMsg = ''
      bindInviteCode(this.bindCode.trim())
        .then(() => {
          this.boundInviteCode = this.bindCode.trim().toUpperCase()
          this.bindMsg = ''
        })
        .catch(err => {
          this.bindMsg = err.message || '填写失败'
        })
        .finally(() => {
          this.binding = false
        })
    },
    copyMyCode() {
      this.doCopy(this.myInviteCode, '邀请码已复制')
    },
    copyLink() {
      this.doCopy(this.inviteLink, '邀请链接已复制')
    },
    copyShareText() {
      this.doCopy(this.shareText, '分享文案已复制')
    },
    doCopy(text, okMsg) {
      copyText(text)
        .then(() => {
          alert(okMsg)
        })
        .catch(() => {
          alert('复制失败，请手动复制')
        })
    }
  }
}
</script>

<style scoped>
.invite-page {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding-top: 8px;
}

.invite-panel,
.stats-panel {
  border-radius: 20px;
  background: #fff;
  padding: 20px 24px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
}

.stats-panel {
  margin-top: 20px;
  background: #f7f7fd;
}

.panel-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.panel-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.panel-desc {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: #666;
}

.highlight {
  color: var(--primary);
  font-weight: 500;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 999px;
  background: linear-gradient(90deg, #1976d2, #0288d1);
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
}

.grid-two {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

@media (min-width: 900px) {
  .grid-two {
    grid-template-columns: 1fr 1fr;
  }
}

.sub-card {
  padding: 16px;
  border-radius: 16px;
  background: #f7f7fd;
}

.sub-card h2 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.sub-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #666;
}

.field-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.field-row.mt {
  margin-top: 16px;
}

.field-label {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.field-input {
  flex: 1;
  min-width: 120px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #dbeafe;
  border-radius: 16px;
  background: #fff;
  font-size: 14px;
}

.field-textarea {
  flex: 1;
  min-width: 120px;
  min-height: 72px;
  padding: 10px 14px;
  border: 1px solid #dbeafe;
  border-radius: 16px;
  background: #fff;
  font-size: 14px;
  resize: none;
}

.btn-primary-sm,
.btn-outline-sm {
  height: 36px;
  min-width: 96px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 13px;
  white-space: nowrap;
}

.btn-primary-sm {
  background: var(--primary);
  color: #fff;
}

.btn-primary-sm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-outline-sm {
  border: 1px solid var(--primary);
  background: #fff;
  color: var(--primary);
}

.hint {
  margin: 10px 0 0;
  font-size: 13px;
}

.hint.ok {
  color: #059669;
}

.hint.warn {
  color: #b45309;
}

.stats-head h2 {
  margin: 0;
  font-size: 22px;
  color: #333;
}

.stats-head p {
  margin: 6px 0 0;
  font-size: 14px;
  color: #666;
}

.stats-card {
  margin-top: 16px;
}

.stat-item {
  display: inline-block;
  padding: 20px 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f0f7ff, #e3f2fd);
  border: 1px solid rgba(25, 118, 210, 0.15);
}

.stat-label {
  font-size: 14px;
  color: #333;
}

.stat-value {
  margin-top: 12px;
  font-size: 34px;
  font-weight: 700;
  color: #8343ff;
  line-height: 1;
}

.stat-value .unit {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #333;
}

.table-wrap {
  margin-top: 20px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dbeafe;
  background: #fff;
}

.table-head,
.table-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 0.8fr;
  gap: 12px;
  padding: 12px 20px;
  font-size: 14px;
}

.table-head {
  background: #dbeafe;
  color: #666;
}

.table-row {
  border-top: 1px solid #dbeafe;
  color: #333;
}

.table-empty {
  padding: 48px 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
}
</style>
